module.exports = __webpack_public_path__ + "img/dsci0017.dc606a87.jpg";